import { render, staticRenderFns } from "./NewTaskCenter.vue?vue&type=template&id=f0520d60&scoped=true"
import script from "./NewTaskCenter.vue?vue&type=script&lang=js"
export * from "./NewTaskCenter.vue?vue&type=script&lang=js"
import style0 from "./NewTaskCenter.vue?vue&type=style&index=0&id=f0520d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0520d60",
  null
  
)

export default component.exports